import { mapGetters } from 'vuex';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import veteransWelcome from '@/veterans/components/veteranswelcome/veterans-welcome.vue';
import mvtFaq from '@/common/components/mvtfaq/mvt-faq.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import { resolveClickCta } from '@/common/utilities/nojq/_utilities.js';

export default {
    name: 'vVeterans',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        veteransWelcome,
        mvtFaq,
        mvtHeader,
        mvtFooter,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
    },
    data: function () {
        return {
            faqs: [
                {
                    question: 'What is the advantage of a VA loan?',
                    answer: 'No down payment (0%), No private mortgage insurance, Low closings costs, and Quick closing times',
                },
            ],
        };
    },
    methods: {
        openHotlead() {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadTitle: 'Meet a Veterans Agent Now',
                    hotleadType: 'veteranshublead',
                    buttonText: 'Connect Now',
                    showZipcode: false,
                    profileUrl: this.glb.cdnUrl + 'vimages/assignedAgent.jpg',
                    isVeteransHub: true,
                    showGeo: true,
                },
            });
        },
        show3rdPartyForm(id, url, evt) {
            this.$eventBus.$emit('eventbus-pop-3rdparty', {
                id: id,
                url: url,
                trigger: this.$options.name,
                cta: resolveClickCta('', evt, 'SEARCH'),
            });
        },
    },
};
